import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Homepage } from './Pages/Homepage/Homepage';
import { Navbar } from './Components/Navbar/Navbar';
import { Navbar2 } from './Components/Navbar/Navbar2';
import { useLocation } from 'react-router-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Blogpage } from './Pages/Blogpage/Blogpage';
import { Footer } from './Components/Footer/Footer';
import Allblogs from './Pages/Blogpage/Allblogs';
import Dashboard from './Components/Dashboard/Dashboard';
import Blogsforhome from './Components/Blogs/Blogsforhome';
 
function App() {

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path="/" element={<Blogsforhome />} />
        <Route path='/Allblogs' element={<Allblogs />} />
        <Route path="/blog/:slugurl" element={<Blogpage />} />
        <Route path='/Dashboard' element={<Dashboard />} />
      </Routes>
      <Footer id="fotr" />
    </BrowserRouter>
  );
}

function Header() {
  const location = useLocation();

  if (location.pathname === "/Dashboard") {
    return null;
  }

  return location.pathname === "/Blogpage" ? <Navbar2 /> : <Navbar />;
}



export default App;
